(() => {
  'use strict';
  if (window.SCPWishlistStore) return;
  const keys=['wishlist','wishlist_handles','wishlist_variant_state_v1','wishlist_last_modified'];
  const validId=id=>/^\d+$/.test(String(id));
  const rawId=id=>Number.isSafeInteger(Number(id))?Number(id):id;
  const read=()=>{
    const raw=keys.map(key=>localStorage.getItem(key));
    const items=JSON.parse(raw[0]||'[]'),handles=JSON.parse(raw[1]||'{}'),meta=JSON.parse(raw[2]||'{"version":1,"products":{}}');
    if(!Array.isArray(items)||items.some(id=>!validId(id))||!handles||typeof handles!=='object'||Array.isArray(handles)||!meta||meta.version!==1||!meta.products||typeof meta.products!=='object'||Array.isArray(meta.products))throw Error('storage');
    for(const [pid,record] of Object.entries(meta.products))if(!validId(pid)||!record||typeof record.productOnly!=='boolean'||!Array.isArray(record.variants)||record.variants.some(v=>!v||!validId(v.id)||typeof v.title!=='string'))throw Error('storage');
    const entries=[];
    for(const pid of [...new Set(items.map(String))]){
      const record=meta.products[pid];
      if(!record||record.productOnly||!record.variants.length)entries.push({key:'p:'+pid,pid,vid:null,title:null});
      for(const [variantIndex,variant] of (record?.variants||[]).entries())if(!entries.some(e=>e.key==='v:'+pid+':'+variant.id))entries.push({key:'v:'+pid+':'+variant.id,pid,vid:String(variant.id),title:variant.title,variantIndex});
    }
    return{raw,items,handles,meta,entries};
  };
  let queue=Promise.resolve();
  const locked=action=>{
    const run=()=>window.navigator?.locks?window.navigator.locks.request('scp-wishlist-v1',action):action();
    const next=queue.then(run,run);queue=next.catch(()=>{});return next;
  };
  const commit=(state,before,origin)=>{
    if(JSON.stringify(state.items)===JSON.stringify(before.items)&&JSON.stringify(state.handles)===JSON.stringify(before.handles)&&JSON.stringify(state.meta)===JSON.stringify(before.meta))return before;
    const values=[JSON.stringify(state.items),JSON.stringify(state.handles),JSON.stringify(state.meta),String(Date.now())];
    if(keys.some((key,index)=>localStorage.getItem(key)!==state.raw[index]))throw Error('conflict');
    const written=[];
    try{
      keys.forEach((key,index)=>{
        if(index===1&&JSON.stringify(state.handles)===JSON.stringify(JSON.parse(state.raw[1]||'{}')))return;
        if(index===2&&JSON.stringify(state.meta)===JSON.stringify(JSON.parse(state.raw[2]||'{"version":1,"products":{}}')))return;
        localStorage.setItem(key,values[index]);written.push(index);
      });
    }catch(error){for(const index of written.reverse()){try{if(state.raw[index]===null)localStorage.removeItem(keys[index]);else localStorage.setItem(keys[index],state.raw[index]);}catch{}}throw error;}
    const after=read();
    const detail={before:before.entries,entries:after.entries,wishlist:after.items,origin};
    window.dispatchEvent(new CustomEvent('scp:wishlist-change',{detail}));
    window.dispatchEvent(new CustomEvent('wishlist-updated',{detail:{wishlist:after.items,action:origin}}));
    return after;
  };
  const recordFor=(state,pid)=>state.meta.products[pid]||(state.meta.products[pid]={productOnly:state.items.some(id=>String(id)===pid),variants:[]});
  const retainProduct=(state,pid)=>{if(!state.items.some(id=>String(id)===pid))state.items.push(rawId(pid));};
  const pruneProduct=(state,pid)=>{const record=state.meta.products[pid];if(record&&!record.productOnly&&!record.variants.length)state.items=state.items.filter(id=>String(id)!==pid);};
  const perform=(action,origin='user')=>locked(()=>{
    const before=read(),state={...before,items:[...before.items],handles:{...before.handles},meta:JSON.parse(JSON.stringify(before.meta))};
    action(state,before);return{before,after:commit(state,before,origin)};
  });
  const remove=key=>perform((state,before)=>{
    const entry=before.entries.find(e=>e.key===key);if(!entry)return;
    const record=recordFor(state,entry.pid);
    if(entry.vid)record.variants=record.variants.filter(v=>String(v.id)!==entry.vid);else record.productOnly=false;
    pruneProduct(state,entry.pid);
  }).then(result=>{
    const removed=result.before.entries.filter(e=>!result.after.entries.some(x=>x.key===e.key));
    return{removed,added:[],positions:result.before.items.map((value,index)=>({pid:String(value),index,value})).filter(record=>removed.some(entry=>entry.pid===record.pid))};
  });
  const toggle=(pid,vid,handle,title='')=>{
    pid=String(pid);vid=vid===null?null:String(vid);
    if(!validId(pid)||(vid!==null&&!validId(vid))||typeof handle!=='string'||!/^[a-zA-Z0-9][a-zA-Z0-9-]*$/.test(handle))return Promise.reject(Error('selection'));
    return perform((state,before)=>{
      const record=recordFor(state,pid),key=vid?'v:'+pid+':'+vid:'p:'+pid;
      if(vid){
        if(record.variants.some(v=>String(v.id)===vid))record.variants=record.variants.filter(v=>String(v.id)!==vid);
        else{record.variants.push({id:vid,title:String(title).slice(0,300)});record.productOnly=false;retainProduct(state,pid);}
      }else{
        const active=before.entries.some(e=>e.pid===pid);
        if(active){record.productOnly=false;record.variants=[];}else{record.productOnly=true;retainProduct(state,pid);}
      }
      state.handles[pid]=handle;pruneProduct(state,pid);
    },'button').then(result=>{
      const removed=result.before.entries.filter(e=>!result.after.entries.some(x=>x.key===e.key));
      const added=result.after.entries.filter(e=>!result.before.entries.some(x=>x.key===e.key));
      return{removed,added,positions:result.before.items.map((value,index)=>({pid:String(value),index,value})).filter(record=>removed.some(entry=>entry.pid===record.pid))};
    });
  };
  const undo=change=>perform(state=>{
    for(const entry of change.added||[]){const record=recordFor(state,entry.pid);if(entry.vid)record.variants=record.variants.filter(v=>String(v.id)!==entry.vid);else record.productOnly=false;pruneProduct(state,entry.pid);}
    for(const entry of change.removed||[]){
      const record=recordFor(state,entry.pid);
      if(entry.vid){if(!record.variants.some(v=>String(v.id)===entry.vid))record.variants.splice(Math.min(entry.variantIndex??record.variants.length,record.variants.length),0,{id:entry.vid,title:entry.title||''});}else record.productOnly=true;
      if(!state.items.some(id=>String(id)===entry.pid)){
        const positions=change.positions?.filter(p=>p.pid===entry.pid)||[];
        if(positions.length)positions.forEach(position=>state.items.splice(Math.min(position.index,state.items.length),0,position.value));else state.items.push(rawId(entry.pid));
      }
    }
  });
  const hydrate=ids=>locked(()=>{
    if(!Array.isArray(ids)||ids.some(id=>!validId(id)))return;
    const before=read(),state={...before,items:[...before.items]};
    for(const id of ids){const pid=String(id),record=state.meta.products[pid];if(record&&!record.productOnly&&!record.variants.length)continue;if(!state.items.some(x=>String(x)===pid))state.items.push(id);}
    if(state.items.length===before.items.length)return;
    commit(state,before,'hydrate');
  });
  window.SCPWishlistStore={read,toggle,remove,undo,hydrate};
  window.dispatchEvent(new CustomEvent('scp:wishlist-ready'));
})();
